<div class="pages-group">
  <div class="page-list">
    @for(field of field.fieldGroup; track $index) {
      @if(hasVisibleChildren(field) && isPageVisibleByExpression(field)) {
        <div (click)="selectPage($index, field)" class="page-item" >
          <span class="page-title" [class.selected]="isPageSelected($index)" [appTooltip]="getNamesOfInvalidFieldsInPage(field)" tooltipPosition="right">
            {{(field.props?.['label'] || 'unknown') | translate}}
            @if(hasInvalidFieldsInPage(field)) {
              <app-dynamic-icon
                [appTooltip]="getNamesOfInvalidFieldsInPage(field)" tooltipPosition="right"
                class="has-invalid-fields-icon"
                name="fa-solid fa-triangle-exclamation"
                size="small"
                title="{{ 'ERRORS.PAGE_INVALID_FIELDS' | translate }}">
              </app-dynamic-icon>
            }
          </span>
        </div>
      }
    }
  </div>
  <div class="page-nav">
    <ion-button
      class="page-nav-button"
      fill="outline"
      size="small"
      (click)="goToPreviousPage()"
      [disabled]="!canGoPrevious()"
      title="{{ 'COMMON.PREVIOUS' | translate }}">
      <app-dynamic-icon name="fa-solid fa-chevron-left" size="small"></app-dynamic-icon>
      <span class="page-nav-button-text">{{ 'COMMON.PREVIOUS' | translate }}</span>
    </ion-button>

    @if(getCurrentPageEntry(); as currentPage) {
      <div class="page-nav-center">
        <span class="page-nav-label" [appTooltip]="getNamesOfInvalidFieldsInPage(currentPage.field)" tooltipPosition="right">
          {{(currentPage.field.props?.['label'] || 'unknown') | translate}}
        </span>
        @if(hasInvalidFieldsInPage(currentPage.field)) {
          <app-dynamic-icon
            [appTooltip]="getNamesOfInvalidFieldsInPage(currentPage.field)" tooltipPosition="right"
            class="has-invalid-fields-icon"
            name="fa-solid fa-triangle-exclamation"
            size="small"
            title="{{ 'ERRORS.PAGE_INVALID_FIELDS' | translate }}">
          </app-dynamic-icon>
        }
        <span class="page-nav-count">{{ getCurrentPagePosition() }} / {{ getTotalVisiblePages() }}</span>
      </div>
    }

    <ion-button
      class="page-nav-button"
      fill="outline"
      size="small"
      (click)="goToNextPage()"
      [disabled]="!canGoNext()"
      title="{{ 'COMMON.NEXT' | translate }}">
      <span class="page-nav-button-text">{{ 'COMMON.NEXT' | translate }}</span>
      <app-dynamic-icon name="fa-solid fa-chevron-right" size="small"></app-dynamic-icon>
    </ion-button>
  </div>
  <div class="page-fields">
    @for(pageField of field.fieldGroup; track $index) {
      @if(!options.formState.disabled) {
        @if(isPageSelected($index) && isPageVisibleByExpression(pageField)) {
          <div id="{{`page_${$index}`}}" class="page-anchor"></div>
          <formly-field [field]="pageField"></formly-field>
        }
      } @else {
        @if(hasVisibleChildren(pageField) && isPageVisibleByExpression(pageField)) {
          <div id="{{`page_${$index}`}}" class="disabled-page-fields page-anchor">
            <div class="disabled-page-title">
              {{(pageField.props?.['label'] || 'unknown') | translate}}
            </div>
            <div class="disabled-page-content">
              <formly-field [field]="pageField"></formly-field>
            </div>
          </div>
        }
      }
    }
  </div>
</div>